import { useEffect, useState } from "react";
// import axios from 'axios';
import { DateInputFormat } from "@/common/DateComponents";
import { addDays, format, isEqual } from "date-fns";
import { connect } from "react-redux";

// import {Actions as ACTIONS} from '../../store/actions/leaveActions';
import { Actions as PAYROLL_ACTIONS } from "../../store/actions/payrollActions";
// import {Actions as INVITE_ACTIONS} from '../../store/actions/employeeActions';
// import {Actions as PAYMENTACTIONS} from '../../store/actions/paymentActions';
// import {Actions as ALLOWANCEACTIONS} from '../../store/actions/allowanceActions';
import { Actions as PAYPERIODACTIONS } from "../../store/actions/payPeriodActions";

import DatePicker from "react-datepicker";

import { ChevronDownIcon } from "@/icons/outline";
import Spinner from "../common/Spinner";

const PayrollPeriod = ({
	id,
	periodStart,
	periodEnd,
	leaveCutOff,
	overtimeCutOff,
	casualStartDate,
	casualEndDate,
	payPeriods,
	companyID,
	payDay,
	year,
	period,
	defaultHours,
	updatingPayPeriod,
	payrollUpdatePayPeriod,
	getPayPeriods,
	permission,
	payPeriodDetails,
	showResetPeriodStartModal,
	payrollPage,
	includeBonusesUntil,
	jurisdiction,
	disabled,
	periodsWithThisSchedule,
}) => {
	const updatePayPeriod = (update) => {
		payrollUpdatePayPeriod({
			periodStart: update.periodStart ? update.periodStart : periodStart,
			payDay: update.payDay ? update.payDay : payDay,
			periodEnd: update.periodEnd ? update.periodEnd : periodEnd,
			overtimeCutOff: update.overtimeCutOff ? update.overtimeCutOff : overtimeCutOff,
			leaveCutOff: update.leaveCutOff ? update.leaveCutOff : leaveCutOff,
			includeBonusesUntil: update.includeBonusesUntil ? update.includeBonusesUntil : includeBonusesUntil,
		});
	};

	const [showMore, setShowMore] = useState(false); // this will need to check the start dates

	const [startDate, setStartDate] = useState(periodStart && new Date(periodStart));
	const [endDate, setEndDate] = useState(periodEnd && new Date(periodEnd));
	const [payDate, setPayDate] = useState(
		payDay && new Date(payDay?.toLowerCase()?.includes("last") ? periodEnd : payDay),
	);
	const [newestPayDate, setNewestPayDate] = useState();

	useEffect(() => {
		setEndDate(periodEnd && new Date(periodEnd));
	}, [periodEnd]);

	useEffect(() => {
		if (payDay) {
			setPayDate(new Date(payDay?.toLowerCase()?.includes("last") ? periodEnd : payDay));
		}
	}, [payDay]);

	useEffect(() => {
		if (!payPeriods) getPayPeriods();

		if (payPeriods?.length > 0) {
			setNewestPayDate(
				payPeriods
					?.filter(
						(period) =>
							period?.year == payPeriodDetails?.year &&
							period?.paySchedule == payPeriodDetails?.paySchedule &&
							payPeriodDetails.period > period.period,
					)
					.sort((a, b) => (b.period > a.period ? 1 : -1))[0]?.payDay || `${payPeriodDetails?.year}-01-01`,
			);
		}
	}, [payPeriods]);

	if (updatingPayPeriod) {
		return (
			<Spinner
				style={{
					width: "10rem",
					height: "10rem",
					verticalAlign: "middle",
					margin: "auto",
					display: "block",
					marginBottom: 20,
				}}
				className="animate-spin -ml-1 mr-3 h-5 w-5 text-success"
			/>
		);
	}

	if (!id) {
		return null;
	}

	if (
		(payPeriodDetails.complete && payPeriodDetails?.complete != "no") ||
		payPeriodDetails?.complete == "yes" ||
		payrollPage == "done"
	)
		return null;

	return (
		<form
			className="form-horizontal fade-on-tour"
			action=""
			method="post"
			onsubmit="return false;"
			id="pay-period"
		>
			<div
				className="col-xs-12 pl-0 pr-0"
				style={{ paddingTop: 0 }}
			>
				<div
					className="col-sm-4"
					style={{ paddingLeft: 0 }}
				>
					<label htmlFor="example-daterange1">Payday</label>
					<DatePicker
						selected={payDate && new Date(payDate)}
						onChange={(date) => {
							const dateString = format(date, "yyyy-MM-dd");

							updatePayPeriod({
								payDay: dateString,
								periodEnd: periodEnd,
								leaveCutOff: leaveCutOff,
								overtimeCutOff: overtimeCutOff,
							});
						}}
						minDate={addDays(new Date(newestPayDate), 1)}
						maxDate={addDays(new Date(periodEnd), 30)}
						dateFormat="dd/MM/yyyy"
						customInput={<DateInputFormat />}
						disabled={disabled}
						wrapperClassName="full-width"
					/>
				</div>

				<div className="col-sm-4">
					<label htmlFor="example-daterange1">Period Start</label>
					<DatePicker
						selected={periodStart && new Date(periodStart)}
						dateFormat="dd/MM/yyyy"
						disabled={!!periodsWithThisSchedule?.length || disabled}
						onChange={(date) => {
							const dateString = format(date, "yyyy-MM-dd");
							if (date && periodStart && !isEqual(new Date(date), new Date(periodStart)))
								showResetPeriodStartModal(dateString);
						}}
						customInput={<DateInputFormat />}
						wrapperClassName="full-width"
					/>
				</div>

				<div className="col-sm-4">
					<label htmlFor="example-daterange1">Period End</label>
					<DatePicker
						selected={endDate}
						onChange={(date) => {
							const dateString = format(date, "yyyy-MM-dd");

							updatePayPeriod({
								payDay,
								periodEnd: dateString,
								leaveCutOff:
									dateString < leaveCutOff || leaveCutOff == periodEnd ? dateString : leaveCutOff,
								overtimeCutOff:
									dateString < leaveCutOff || overtimeCutOff == periodEnd
										? dateString
										: overtimeCutOff,
							});
						}}
						minDate={addDays(new Date(periodStart), 1)}
						disabled={disabled}
						dateFormat="dd/MM/yyyy"
						customInput={<DateInputFormat />}
						wrapperClassName="full-width"
					/>
				</div>
				{!disabled && (
					<a
						style={{
							fontSize: 11,
							padding: "3px 6px",
							paddingLeft: 0,
							float: "left",
							color: "#ea611c",
							cursor: "pointer",
						}}
						target="_blank"
						href="https://support.buddy.hr/hc/en-mt/articles/360021558419"
					>
						Looking for an older payroll?
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-5 w-5"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
							/>
						</svg>
					</a>
				)}
				<div
					style={{
						fontSize: 11,
						padding: "3px 6px",
						float: "right",
						color: "#ea611c",
						cursor: "pointer",
					}}
					onClick={() => {
						setShowMore(!showMore);
					}}
				>
					{showMore ? "Less Options" : "More Options"}

					<ChevronDownIcon
						style={{
							minWidth: "1.5rem",
							width: "1.5rem",
							marginLeft: 5,
							verticalAlign: "text-bottom",
							cursor: "pointer",
							display: "inline-block",
							textAlign: "center",
							transform: showMore ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.2s ease-in-out",
						}}
					/>
				</div>
			</div>

			{showMore && (
				<div
					className="row"
					style={{ paddingTop: 0 }}
				>
					{jurisdiction == "MT" ? (
						<div className="col-sm-4">
							<label htmlFor="example-daterange">Include Bonuses Until</label>
							<DatePicker
								selected={includeBonusesUntil && new Date(includeBonusesUntil)}
								onChange={(date) =>
									updatePayPeriod({
										includeBonusesUntil: format(date, "yyyy-MM-dd"),
									})
								}
								minDate={periodEnd && new Date(periodEnd)}
								dateFormat="dd/MM/yyyy"
								customInput={<DateInputFormat />}
								disabled={disabled}
								wrapperClassName="full-width"
							/>
						</div>
					) : (
						<div className="col-sm-4"></div>
					)}

					<div className="col-sm-4">
						<label htmlFor="example-daterange">Timesheet/Overtime Cut-Off</label>
						<DatePicker
							selected={overtimeCutOff && new Date(overtimeCutOff)}
							onChange={(date) =>
								updatePayPeriod({
									overtimeCutOff: format(date, "yyyy-MM-dd"),
								})
							}
							maxDate={periodEnd && new Date(periodEnd)}
							dateFormat="dd/MM/yyyy"
							customInput={<DateInputFormat />}
							disabled={disabled}
							wrapperClassName="full-width"
						/>
					</div>

					<div className="col-sm-4">
						<label htmlFor="example-daterange">Leave Cut-Off</label>
						<DatePicker
							selected={leaveCutOff && new Date(leaveCutOff)}
							onChange={(date) =>
								updatePayPeriod({
									leaveCutOff: format(date, "yyyy-MM-dd"),
								})
							}
							maxDate={periodEnd && new Date(periodEnd)}
							dateFormat="dd/MM/yyyy"
							customInput={<DateInputFormat />}
							disabled={disabled}
							wrapperClassName="full-width"
						/>
					</div>
				</div>
			)}
		</form>
	);
};

const mapStateToProps = (state) => {
	const payPeriodDetails = state.payroll && state.payroll.payPeriodDetails;
	const updatingPayPeriod = state.payroll && state.payroll.updatingPayPeriod;
	const payPeriods = state.payPeriods?.periods;
	// payPeriodId,
	// periodStart,
	// periodEnd,
	// casualStartDate,
	// casualEndDate,
	// payPeriods,
	// companyID,
	// payDay,
	// year,
	// period,
	// defaultHours

	return {
		...payPeriodDetails,
		payPeriodDetails,
		payrollPage: state.payroll.payrollPage,
		updatingPayPeriod,
		overtimeCutOff: payPeriodDetails?.overtimeCutOff || payPeriodDetails?.periodEnd,
		leaveCutOff: payPeriodDetails?.leaveCutOff || payPeriodDetails?.periodEnd,
		payPeriods,
		permission: state.permissions && state.permissions.my && state.permissions.my.payroll,
		includeBonusesUntil: payPeriodDetails?.includeBonusesUntil || payPeriodDetails?.periodEnd,
		jurisdiction: state?.company?.settings?.jurisdiction,
		periodsWithThisSchedule: payPeriods?.filter(
			({ paySchedule, id }) => paySchedule === payPeriodDetails?.paySchedule && id != payPeriodDetails?.id,
		),
		// ...state.leave,
		// allowanceUploadErrors: state.allowances.allowanceUploadErrors,
		// allowanceUploadProgress: state.allowances.allowanceUploadProgress,
		// processingTimesheets: state.payroll.processingTimesheets,
		// processedTimesheets: state.payroll.processedTimesheets
	};
};

const mapDispatchToProps = (dispatch) => ({
	payrollUpdatePayPeriod: (params) => dispatch(PAYROLL_ACTIONS.payrollUpdatePayPeriod(params)),
	getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
	showResetPeriodStartModal: (date) => dispatch(PAYROLL_ACTIONS.showResetPeriodStartModal(date)),

	// leaveGetBalances: (until) => dispatch(ACTIONS.leaveGetBalances(until)),
	// uploadPayrollAllowances: (options) => dispatch(ALLOWANCEACTIONS.uploadPayrollAllowances(options)),
	// processTimesheets: () => dispatch(PAYROLL_ACTIONS.processTimesheets(true)),
	// clearProcessTimesheets: () => dispatch(PAYROLL_ACTIONS.clearProcessTimesheets()),
	// showInviteEmployeeModal: () => dispatch(INVITE_ACTIONS.showInviteEmployeeModal(true)),
	// getPaymentStats: () => dispatch(PAYMENTACTIONS.getPaymentStats()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollPeriod);
